import cn from 'classnames';
import React from 'react';

type LightInvoiceFooterProps = {
  invoiceNotes?: string;
  isPdf?: boolean;
};

export const LightInvoiceFooter = ({ invoiceNotes, isPdf }: LightInvoiceFooterProps) => {
  return (
    <div className={cn('mt-auto text-sm', isPdf ? 'pt-2' : 'pt-12')}>
      <p className='text-inactive pb-2 font-thin'>Term & Notes</p>
      <p className='text-black'>{invoiceNotes}</p>
    </div>
  );
};